// Footer.tsx

import React, { useState } from "react";
import { SelectedPage } from "../shared/types";
import Modal from "react-modal";

import PrivacyPolicy from "./Policies/privacy";
import TermsOfService from "./Policies/services";

import { FaLinkedin } from "react-icons/fa"; // Importa l'icona di LinkedIn

type Props = {
  setSelectedPage(value: SelectedPage): void;
};

function Footer({ setSelectedPage }: Props) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState<JSX.Element | null>(null);

  const openModal = (content: JSX.Element) => {
    setModalContent(content);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalContent(null);
    setModalIsOpen(false);
  };
  return (
    <footer className="bg-palette1 text-white text-center p-8">
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-center">
        {/* Section 1 - Company Info */}
        <div className="flex items-center justify-start flex-col">
          <h3 className="text-lg font-bold mb-4">Company Info</h3>
          <p>Dream Innovation Srl</p>
          <p>Via F. Parri, 1</p>
          <p>Sant'Arpino (CE), 81030</p>
          <p>VAT: 03915620615</p>
        </div>

        {/* Section 2 - Quick Links */}
        <div className="flex items-center justify-start flex-col">
          <h3 className="text-lg font-bold mb-4">Quick Links</h3>
          <ul className="list-none">
            <li>
              <p
                className="hover:underline cursor-pointer"
                onClick={() => openModal(<PrivacyPolicy />)}
              >
                Privacy Policy
              </p>
            </li>
            <li>
              <p
                className="hover:underline cursor-pointer"
                onClick={() => openModal(<TermsOfService />)}
              >
                Terms of Service
              </p>
            </li>
            {/* Add more links as needed */}
          </ul>
        </div>

        {/* Section 3 - Contact Info */}
        <div className="flex items-center justify-start flex-col">
          <h3 className="text-lg font-bold mb-4">Contact Us</h3>
          <p>Email: info@dreaminnovation.it</p>
          <a
            href="https://www.linkedin.com/company/76173272/admin/feed/posts/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xl mt-4"
          >
            <FaLinkedin />
          </a>
          
        </div>
        
      </div>

      {/* Copyright and Disclaimer */}
      <div className="text-center mt-8">
        <p className="text-sm">
          © {new Date().getFullYear()} Dream Innovation. All rights reserved.
        </p>
        <p className="text-xs">www.dreaminnovation.it</p>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="bg-white p-8 rounded-md shadow-md sm:w-1/2 w-full mx-auto mt-16"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      >
        <div className="flex justify-end">
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={closeModal}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </button>
        </div>
        <div className="flex flex-col items-center justify-center">
          <div className="max-h-96 overflow-y-auto ">{modalContent}</div>
          <button
            onClick={closeModal}
            className="bg-palette5 text-palette3 border border-palette3 py-2 px-4 rounded-full mx-auto mt-4 hover:bg-palette3 hover:text-palette5 transition-colors"
          >
            Close
          </button>
        </div>
      </Modal>
    </footer>
  );
}

export default Footer;
